<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [];
		for(const code of this.$countryCode){
            options.push({ value: code[2], label: code[2] });
		}
		return{
			options,
		}
	},
	props:['value'],
}
</script>

